import { gql } from '@apollo/client/core'

// Own name: the DraftLogicClauseProposition fragment omits the audience variant, and two fragments of one
// name cannot share a document. Refs are not selected — the backend remints them on every save.
const AUDIENCE_QUESTION_LOGIC = gql`
  fragment AudienceQuestionLogic on DraftLogicClauseProposition {
    negated
    proposition {
      ... on DraftAudienceReponseOption {
        surveyId
        questionId
        responseOptionId
      }
    }
  }
`

export default AUDIENCE_QUESTION_LOGIC
